<div class="padding flex column">
    <h4 class="bold margin-bottom-small">Add products</h4>

    <form [formGroup]="form">

        <div class="flex column margin-top">
            <span class="bold">Warehouse</span>
            <mat-form-field appearance="outline" class="margin-top-small">
                <input type="text" matInput formControlName="warehouse" [matAutocomplete]="autoWarehouse" />
                <mat-autocomplete #autoWarehouse="matAutocomplete" [displayWith]="displayWarehouse">
                    @for (warehouse of warehouses.data; track warehouse) {
                    <mat-option inViewport (inViewportAction)="inViewportActionWarehouse($event, warehouse)" [value]="warehouse">{{warehouse.fullName}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div class="flex column margin-top">
            <span class="bold">Styles</span>
            <mat-form-field appearance="outline" class="margin-top-small">
                <input type="text" matInput formControlName="style" [matAutocomplete]="autoStyle" />
                <mat-autocomplete #autoStyle="matAutocomplete" [displayWith]="displayStyle">
                    @for (style of styles.data; track style) {
                    <mat-option inViewport (inViewportAction)="inViewportActionStyles($event, style)" [value]="style">{{style.fullName}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div class="flex column margin-top">
            <span class="bold">Colors</span>
            <mat-form-field appearance="outline" class="margin-top-small">
                <input type="text" matInput [formControl]="colorSearchControl" [matAutocomplete]="autoColor" />
                <mat-autocomplete #autoColor="matAutocomplete" [displayWith]="displayColor" (optionSelected)="onColorSelected($event.option.value)">
                    @for (color of colorsAvailable; track color.colorId) {
                        <mat-option inViewport (inViewportAction)="inViewportActionColors($event, color)" [value]="color">{{ color.fullName }}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <div class="colors-chips-wrap">
                <mat-chip-set #chipSet>
                    @for (c of form.get('colors')?.value; track c.colorId) {
                    <mat-chip (removed)="removeColor(c)">{{ c.fullName }}
                        <button matChipRemove>
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </button>
                    </mat-chip>
                    }
                </mat-chip-set>
            </div>
        </div>

    </form>

    <div class="flex column end margin-top">
        <div class="flex center">
            <button (click)="onClose(false)" class="stroked margin-right-small">
                <mat-icon>undo</mat-icon>
                Discard
            </button>

            <button (click)="onClose(true)" [disabled]="!form.valid">
                <mat-icon>check</mat-icon>
                Confirm
            </button>
        </div>
    </div>
</div>